/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetProductFiles = async (productId, params = {}) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/products/${productId}/files?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateProductFolder = async (data) => {
  return Request.call({
    url: `/micro/products/folder`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDeleteProductFiles = async (productId, data) => {
  return Request.call({
    url: `/micro/products/${productId}/delete/files`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiProductUploadFileToFolder = async (productId, data) => {
  return Request.call({
    url: `/micro/products/${productId}/files`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiProductMoveFileFolderV2 = async (productId, data) => {
  return Request.call({
    url: `/micro/products/${productId}/files`,
    method: 'PATCH',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSharedProductDocumentToken = async (productId, data) => {
  return Request.call({
    url: `/micro/products/${productId}/files/shared`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetComplianceTypes = (params) => {
  return Request.call({
    url: `/micro/compliances/certification-types`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetComplianceCustomOptions = (params) => {
  return Request.call({
    url: `/micro/compliances/custom-options`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDuplicateProduct = (id) => {
  return Request.call({
    url: `/micro/products/${id}/duplicate`,
    method: 'POST',
    data: {},
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
